import { render } from "./IndexHome.vue?vue&type=template&id=6b6fa136&scoped=true"
import script from "./IndexHome.vue?vue&type=script&lang=js"
export * from "./IndexHome.vue?vue&type=script&lang=js"

import "./IndexHome.vue?vue&type=style&index=0&id=6b6fa136&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b6fa136"]])

export default __exports__